<template>
  <div id="hnr_video_wrap">
    <div class="hnr_video">
      <van-skeleton :row="18" v-if="!info.title" />

      <template v-if="info.title">
        <div class="hnr_mainwrap">
          <div class="hnr_viedo_img" v-if="liveState == 'preWithIMG'">
            <img :src="info.coverIMG" alt />
          </div>

          <div
            class="hnr_pre_video"
            v-if="
              liveState == 'preWithVideo' ||
              liveState == 'ing' ||
              liveState == 'end'
            "
          >
            <div id="hnr_pre_video_el" ref="hnr_pre_video_el"></div>
          </div>
        </div>
        <div class="main_info">
          <div class="newsdetail_header">
            <div class="channel">
              <Icon v-if="liveState" :state="liveState" :info="info" @begin-live="reload"></Icon>
            </div>

            <div class="title">{{ info.title }}</div>

            <div class="introduction">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAArBJREFUWAntVTtsE0EQnT07xgIElJEiEL4LdmIaKhQUEEFCQIWUDopINBSUEDqQiASiRaLhW0AHDQU9Db8mdAjbd8G+JAiEEA0S4mP7dpi14tP+zhcTCopbyfLOmze3797O3gJkI3Mgc+A/ciAIwn21Rut14/3ykb+RFQQr7ju/+ayx1DqZVM+SEjpeC1qXkOMC4XnG4BvLw6FJz3ur85Limt+aQ4RbALgFgP3IjeQPT3i73uj8VEGIWKgH4X36n5OLSdTHQq54YHx87IOM2+Z1P7zCkS+oOfaZFWCq6rorMu7IgT4nEawetB7qYgSP3nasHf0+rtfoMW3xVVNM7wmjrMtO6Py8DshxIwiv0cKnZGxt3nUc5+xkufTAkoshcvYM5/xyDKxNGGOcfueo/q6R04F+XFsKp4DjK3JHcVE8zHFgdmKP+7TPtf2LBu7wiHoMN+t5xpzT1UrpkY6LWFmsT+iJiPg9XUwvj3A9TYzgdTG6nSDmRpIYUWdt6pq/PIsYPREEZTB4WS27M+RSpOBa4PvNg12EFxpMq7HFark0TfUdI7cGWB0C4OetBcy5mCZG1JHaC9Z6gPlBYkSN4VAYhqM/2/iJtkvN0dvtrbj7ExaK4Wazuf1XB74SoB6YddYbDpGYY4YYoRzhTrzqgEk7gqOGGMFHuDmgLE4ZghBgOs5KEyIuSmHilCObsSWLI/jchuuYIYicKOsk0Te5XMnXcVtM+1wxcAZfPM9bNXALoPYJEejyWyV7d2rc73RCjI+Y4FBfzctc+jKHCLhbxsQ1g8Aey1h/rterjUcsUriNtk0fW+muSDw5MpmOwg56IWWIa4aaaF31xpaRpE3K04YM6IWKQ5YodIsgKCiM4YMN1dsEDS/hH1ZkgtLMzBzKHEpzIC2f9VCaQ1k+c2CjDvwB9bjhFwn+VBgAAAAASUVORK5CYII="
                alt
                class="icon-yinhao icon-yinhao-left"
              />
              <div class="introduction-main">
                <div>{{ info.des }}</div>
              </div>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAp9JREFUWAntVr2L1FAQf5PEPcTeQsEj2TP7YWMjWKighSCI9VWnhXqCINjKCSdYKKJYCtcIIlxzhdj4iYIf+Ae4H0nM5g4RvE6FO9S9zTjvJOzbeS/uyhZaZJvM7zfzm8zMey9vhSh+xQTGmwBweaMdI+fyMACk9Ypnq/5x9Zaa7H+wi4KGrUIxoWJCwyYwzF/sITYh7SM87oR+sBf8LexywVgFUXtjFoSa3uEVCoBbGkcEoJhGgTtUH3FfVLxp5+gFilkhcJsaTw19U7G0tcuVB2S4EcSrlHR7huWTLtendLkeVTmTHUU40U2TNUQcuIgp9sWeavmIqhlpyeI43sWLkUmow0BNlmf3eknFUIzsKOKakQr63oVDXCixBfjSxHMuFWIf5ySm5XnD+ZEKIuUFLiS8UbLFMwOvUQhy/wz+aLlxawmeDLLUJCc4bgSdgwJR6xBAPCyXy195PMfNKNlv0lPcK9d1P/P4PxZE676FBDe5SGLancbTqMbKfYNpekPl+rZ1u2/3Lf3Y932iFS5fN3UnT1el4r1WQo1mK0jmyXGAO2nvvK/5kw84L3HuhJpBMo2YXtRFsO6AfU7nB5l21DlBe+/SILv5qUiFbZ2R/8e5T2JjQa0wOUuH+r5RYMF535/smHwZR/pTvR4u0ZJp+Wk61+q73XdZLH9qS0bJZtM0vcMDJQYBV2u+e9fky7hm0DlN+oUMq086CItV351TOW5rHaCDj+iDtaoFgjVfr3qXOc9xyZ54TC/+xHlaons13zspjzv3qVgrqO55K7bjHKd5rP8OhDVKMlOruFdUYZ49NbXzIzjiGBWVfRI2wII5umJmKM/PPN1QXm5Kur+eh+GKNzTYEND+sHy42e68DcNkr8FdUMUEign8swn8AkPBv7laTiK7AAAAAElFTkSuQmCC"
                alt
                class="icon-yinhao icon-yinhao-right"
              />
            </div>
          </div>

          <div class="zhibo_message">
            <!-- <div class="zhibo_message_title">直播间</div> -->
            <div class="zhibo_message_list">
              <div class="block">
                <el-timeline>
                  <el-timeline-item
                    v-for="(item, index) in message"
                    :timestamp="item.time"
                    placement="top"
                    color="#da4346"
                    :size="index == 0 ? 'large' : 'normal'"
                    :key="item.id"
                  >
                    <el-card>
                      <div class="zhibo_message_list_title">{{ item.title }}</div>
                      <div class="zhibo_message_list_des">{{ item.des }}</div>
                      <div class="zhibo_message_list_img" v-if="item.img">
                        <van-image width="100%" :src="item.img" @click="preIMG(item.img)" />
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

import micromatch from "micromatch";

import { getZhiboInfo, getZhiboMessage } from "../sdk/sdk";

import player from "../util/player";

import Icon from "@/components/ZhiBoIcon.vue";

import { ImagePreview } from "vant";

export default {
  components: {
    Icon,
  },
  data() {
    return {
      id: "",
      info: false,
      // 毫秒单位
      currentTime: Date.parse(new Date()),
      message: [],
    };
  },

  // 获取ID
  async mounted() {
    this.id = this.getArticleID();
    const res = await getZhiboInfo(this.id);
    const res_message = await getZhiboMessage(this.id);

    if (res.state === 1) {
      this.info = res.data;

      this.$nextTick(() => {
        this.viedeoCheck();
      });
    } else {
      Dialog({ message: "获取直播信息失败！" + res.message });
    }

    if (res_message.state == 1) {
      this.message = res_message.data;
    } else {
      Dialog({ message: "获取直播信息列表失败！" + res_message.message });
    }
  },
  methods: {
    // 获取文章id
    getArticleID() {
      console.log(process.env.NODE_ENV);
      let url_str = "";
      // 自动判断生产环境和开发环境，以免忘记添加
      if (process.env.NODE_ENV == "development") {
        url_str = "http://news.hnr.cn/newszhibo/article/1/1522125099673124865";
      } else {
        url_str = window.location.href;
      }

      const url = new URL(url_str);

      const res_res = micromatch.capture("/*/article/1/*", url.pathname);

      console.log(res_res);

      if (res_res && res_res.length) {
        return res_res[1];
      } else {
        // 获取id失败
        Dialog({ message: "获取文章ID失败！" });
      }

      this.id = document.getElementById("#weixin_share .article_id");
    },
    // 视频检查挂载
    viedeoCheck() {
      switch (this.liveState) {
        //预告视频
        case "preWithVideo":
          player(
            this.$refs.hnr_pre_video_el,
            this.info.previewedUrl,
            this.info.coverIMG,
            false
          );
          break;
        // 直播中，自动播放
        case "ing":
          player(
            this.$refs.hnr_pre_video_el,
            this.info.liveUrl.adr720,
            this.info.coverIMG,
            true,
            true
          );
          break;
        // 直播结束
        case "end":
          player(
            this.$refs.hnr_pre_video_el,
            this.info.backUrl??this.info.liveUrl.adr720,
            this.info.coverIMG,
            false,
            false
          );
          break;
        default:
          break;
      }
    },
    preIMG(src) {
      ImagePreview([src]);
    },
    reload() {
      window.location.reload();
    },
  },
  computed: {
    liveState() {
      // 预告状态:当前时间小于开始时间
      if (this.info) {
        const time = this.currentTime - this.info.beginTime;

        // 小于0说明直播未开始
        if (time < 0) {
          // 未开始没有预告片
          if (this.info.previewedState == 0) {
            return "preWithIMG";
          } else if (this.info.previewedState == 1) {
            return "preWithVideo";
          } else if (this.info.previewedState == 2) {
            // 直播河南
            return "preWithZBHN";
          }
          return false;
        }
        // 判断直播中的情况
        if (this.currentTime < this.info.closeTime) {
          return "ing";
        }
        // 直播结束
        return "end";
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
#hnr_video_wrap {
  padding-top: 1.4rem;
}
.hnr_video {
  width: 100%;
  min-height: 5.626667rem;
  padding-top: 0.2rem;
}

.hnr_mainwrap {
  width: 9.6rem;
  height: 5.6rem;
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
}

.hnr_viedo_img {
  width: 100%;
  height: 100%;
}

.hnr_viedo_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.main_info {
  margin-top: 0.2rem;
}

.newsdetail_header {
  padding: 0.3rem;
  padding-top: 0.2rem;
  background-color: #fff;
  position: relative;
}

.newsdetail_header .channel {
  margin-bottom: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.newsdetail_header .channel_name {
  color: #666;
  position: relative;
}

.newsdetail_header .title {
  font-size: 0.6rem;
  color: #000;
  margin-bottom: 0.5rem;
  line-height: 0.8rem;
  font-weight: 700;
  letter-spacing: 2px;
}

.newsdetail_header .author,
.newsdetail_header .date {
  color: #666;
  font-size: 0.38rem;
}

.newsdetail_header .date {
  margin-bottom: 0.4rem;
}

.introduction {
  position: relative;
  padding: 0.266667rem;
  font-size: 0.4rem;
  color: #666;
  letter-spacing: 0;
  line-height: 0.6rem;
  background: #f5f5f5;
  border-radius: 5px;
}

.introduction .icon-yinhao-left {
  top: -10px;
  left: 10px;
}

.introduction .icon-yinhao {
  position: absolute;
  width: 18px;
  height: 18px;
}

.introduction-main.hide {
  overflow: hidden;
}

.introduction-main {
  position: relative;
}

.introduction .icon-yinhao-right {
  bottom: -10px;
  right: 10px;
}

.introduction .icon-yinhao {
  position: absolute;
  width: 18px;
  height: 18px;
}

#hnr_video_wrap .van-tag--large {
  font-size: 18px;
  line-height: 24px;
}

.hnr_pre_video {
  width: 100%;
  height: 100%;
}

.xgplayer-enter-logo {
  background-image: url("http://d1.hnr.cn/weixinshare/wx_share_zhibo.png") !important;
  width: 100px !important;
  height: 100px !important;
  background-size: cover !important;
  top: 39% !important;
  margin-left: -51px !important;
}

.xgplayer-enter-tips {
  display: none !important;
}

.zhibo_message {
  padding: 0.3rem;
}

.zhibo_message_list_title {
  font-size: 0.4rem;
  font-weight: bold;
}

.zhibo_message_list_des {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  font-size: 0.35rem;
}

.zhibo_message_list_img {
  width: 100%;
}

.zhibo_message_list_img img {
  width: 100%;
}

#hnr_video_wrap .el-card__body {
  padding: 0.3rem;
}
</style>